"use strict";
/**
 *  Copyright (c) Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE file in the root directory of this source tree.
 */

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var cx = require("classnames");
var firstTime = true;
/**
 * ExecuteButton
 *
 * What a nice round shiny button. Shows a drop-down when there are multiple
 * queries to run.
 */
var ExecuteButton = function (_super) {
    __extends(ExecuteButton, _super);
    function ExecuteButton(props) {
        var _this = _super.call(this, props) || this;
        _this._onClick = function () {
            if (_this.props.isRunning) {
                _this.props.onStop();
            } else {
                _this.props.onRun();
            }
        };
        _this._onOptionSelected = function (operation) {
            _this.setState({ optionsOpen: false });
            _this.props.onRun(operation.name && operation.name.value);
        };
        _this._onOptionsOpen = function (downEvent) {
            var initialPress = true;
            var downTarget = downEvent.target;
            _this.setState({ highlight: null, optionsOpen: true });
            var _onMouseUp = function onMouseUp(upEvent) {
                if (initialPress && upEvent.target === downTarget) {
                    initialPress = false;
                } else {
                    document.removeEventListener('mouseup', _onMouseUp);
                    _onMouseUp = null;
                    var isOptionsMenuClicked = downTarget.parentNode.compareDocumentPosition(upEvent.target) & Node.DOCUMENT_POSITION_CONTAINED_BY;
                    if (!isOptionsMenuClicked) {
                        _this.setState({ optionsOpen: false });
                    }
                    if (firstTime) {
                        _this._onOptionSelected(_this.props.operations.find(function (op) {
                            return op.name.value === upEvent.target.textContent;
                        }));
                        firstTime = false;
                    }
                }
            };
            document.addEventListener('mouseup', _onMouseUp);
        };
        _this.state = {
            optionsOpen: false,
            highlight: null
        };
        return _this;
    }
    ExecuteButton.prototype.render = function () {
        var _this = this;
        var operations = this.props.operations;
        var optionsOpen = this.state.optionsOpen;
        var hasOptions = operations && operations.length > 1;
        var options = null;
        if (hasOptions && optionsOpen) {
            var highlight_1 = this.state.highlight;
            options = React.createElement(
                "ul",
                { className: "execute-options" },
                operations.map(function (operation) {
                    return React.createElement(
                        "li",
                        { key: operation.name ? operation.name.value : '*', className: operation === highlight_1 ? 'selected' : '', onMouseOver: function onMouseOver() {
                                return _this.setState({ highlight: operation });
                            }, onMouseOut: function onMouseOut() {
                                return _this.setState({ highlight: null });
                            }, onMouseUp: function onMouseUp() {
                                return _this._onOptionSelected(operation);
                            } },
                        operation.name ? operation.name.value : '<Unnamed>'
                    );
                })
            );
        }
        // Allow click event if there is a running query or if there are not options
        // for which operation to run.
        var onClick;
        if (this.props.isRunning || !hasOptions) {
            onClick = this._onClick;
        }
        // Allow mouse down if there is no running query, there are options for
        // which operation to run, and the dropdown is currently closed.
        var onMouseDown;
        if (!this.props.isRunning && hasOptions && !optionsOpen) {
            onMouseDown = this._onOptionsOpen;
        }
        var pathJSX = this.props.isRunning ? React.createElement("rect", { fill: "#FFFFFF", x: "10", y: "10", width: "13", height: "13", rx: "1" }) : React.createElement("path", { d: "M0.02,2.23v32.54c0,1.47,1.52,2.42,2.81,1.76l32.08-16.27c1.43-0.73,1.43-2.8,0-3.53L2.83,0.47\n\tC2.54,0.32,2.25,0.25,1.96,0.25C0.94,0.25,0.02,1.09,0.02,2.23z" });
        var width = this.props.isRunning ? 35 : 20;
        return React.createElement(
            "div",
            { className: "execute-button-wrap", "data-jsx": 1087431325
            },
            React.createElement(_style2.default, {
                styleId: 1087431325,
                css: ".execute-button-wrap[data-jsx=\"1087431325\"] {position: absolute !important;left: -62px;z-index: 5;top: 15px;}.graphcool-execute-button[data-jsx=\"1087431325\"] {background-color: rgb(185, 191, 196);border: 6px solid rgb(11, 20, 28);width: 71px;height: 71px;}.graphcool-execute-button[data-jsx=\"1087431325\"]:not(.running) svg[data-jsx=\"1087431325\"] {top: -1px;left: 2px;}.br100,\n.graphcool-execute-button[data-jsx=\"1087431325\"] {border-radius: 100%;}.flex,\n.graphcool-execute-button[data-jsx=\"1087431325\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.graphcool-execute-button[data-jsx=\"1087431325\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.justifyCenter,\n.graphcool-execute-button[data-jsx=\"1087431325\"] {-ms-flex-pack: center;justify-content: center;}.pointer:hover,\n.graphcool-execute-button[data-jsx=\"1087431325\"]:hover {cursor: pointer;}.bgrRed,\n.running[data-jsx=\"1087431325\"] {background-color: #f25c54;}.relative,\n.graphcool-execute-button[data-jsx=\"1087431325\"]:not(.running) svg[data-jsx=\"1087431325\"] {position: relative;}"
            }),
            React.createElement(
                "div",
                { className: cx('graphcool-execute-button', {
                        'running': this.props.isRunning
                    }), onMouseDown: onMouseDown, onClick: onClick, title: "Execute Query (Ctrl-Enter)", "data-jsx": 1087431325
                },
                React.createElement(
                    "svg",
                    { width: width, height: width, viewBox: this.props.isRunning ? "4.5,4.5,24,24" : "0 0 36 37", "data-jsx": 1087431325
                    },
                    pathJSX
                )
            ),
            options
        );
    };
    return ExecuteButton;
}(React.Component);
exports.ExecuteButton = ExecuteButton;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/ExecuteButton.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/ExecuteButton.js
// module chunks = 0